import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { JwtInterceptor } from '../interceptors/JwtInterceptor';
import { ErrorInterceptor } from '../interceptors/ErrorInterceptor';
import { BeforeunloadPlugin } from '../../app/common/util/BeforeunloadPlugin';


import { GridsterModule } from 'angular-gridster2';

/*-- routing import start --*/
import {StreamRoutingModule} from '../../app/pages/admin/stream/StreamRoutingModule';
import {TenantRoutingModule} from '../../app/pages/admin/tenant/TenantRoutingModule';
import {UserRoutingModule} from '../../app/pages/admin/user/UserRoutingModule';
import {CameraRoutingModule} from '../../app/pages/camera/CameraRoutingModule';
import {DashboardRoutingModule} from '../../app/pages/dashboard/DashboardRoutingModule';
import {DevtoolRoutingModule} from '../../app/pages/devtool/DevtoolRoutingModule';
import {LoginRoutingModule} from '../../app/pages/login/LoginRoutingModule';
import {PasswoordRoutingModule} from '../../app/pages/password/PasswoordRoutingModule';
/*-- routing import end --*/

import { AppRoutingModule } from '../../app/AppRoutingModule';

/*-- declarations import start --*/
import {GSAlertDialogComponent} from '../../app/directives/gs-alert/GSAlertDialogComponent';
import {GSCaptureComponent} from '../../app/directives/gs-capture/GSCaptureComponent';
import {GSCaptureMultiComponent} from '../../app/directives/gs-capture-multi/GSCaptureMultiComponent';
import {GSDialogComponent} from '../../app/directives/gs-dialog/GSDialogComponent';
import {GSFooterComponent} from '../../app/directives/gs-footer/GSFooterComponent';
import {GSGridComponent} from '../../app/directives/gs-grid/GSGridComponent';
import {GSHeaderComponent} from '../../app/directives/gs-header/GSHeaderComponent';
import {GSIconComponent} from '../../app/directives/gs-icon/GSIconComponent';
import {GSSidebarComponent} from '../../app/directives/gs-sidebar/GSSidebarComponent';
import {GSVideoComponent} from '../../app/directives/gs-video/GSVideoComponent';
import {GSVideoClipDialogComponent} from '../../app/directives/gs-video/dialog/clip/GSVideoClipDialogComponent';
import {StreamDetailComponent} from '../../app/pages/admin/stream/detail/StreamDetailComponent';
import {StreamIndexComponent} from '../../app/pages/admin/stream/index/StreamIndexComponent';
import {TenantCameraComponent} from '../../app/pages/admin/tenant/camera/TenantCameraComponent';
import {TenantIndexComponent} from '../../app/pages/admin/tenant/index/TenantIndexComponent';
import {TenantDeleteDialogComponent} from '../../app/pages/admin/tenant/index/dialog/delete/TenantDeleteDialogComponent';
import {TenantEntryDialogComponent} from '../../app/pages/admin/tenant/index/dialog/entry/TenantEntryDialogComponent';
import {TenantMenuComponent} from '../../app/pages/admin/tenant/menu/TenantMenuComponent';
import {UserIndexComponent} from '../../app/pages/admin/user/index/UserIndexComponent';
import {UserEntryDialogComponent} from '../../app/pages/admin/user/index/dialog/entry/UserEntryDialogComponent';
import {CameraDetailComponent} from '../../app/pages/camera/detail/CameraDetailComponent';
import {DetectComponent} from '../../app/pages/camera/detect/DetectComponent';
import {CameraIndexComponent} from '../../app/pages/camera/index/CameraIndexComponent';
import {CameraMultiComponent} from '../../app/pages/camera/multi/CameraMultiComponent';
import {DashboardIndexComponent} from '../../app/pages/dashboard/index/DashboardIndexComponent';
import {DevtoolIndexComponent} from '../../app/pages/devtool/index/DevtoolIndexComponent';
import {LoginConfirmComponent} from '../../app/pages/login/confirm/LoginConfirmComponent';
import {LoginIndexComponent} from '../../app/pages/login/index/LoginIndexComponent';
import {PasswordIndexComponent} from '../../app/pages/password/index/PasswordIndexComponent';
import {AppComponent} from '../app/AppComponent';
import {MainLayoutComponent} from '../../core/layouts/main/MainLayoutComponent';
import {TopNavLayoutComponent} from '../../core/layouts/top-nav/TopNavLayoutComponent';
/*-- declarations import end --*/
/*-- service import start --*/
import {AnalyticsService} from '../../app/common/service/AnalyticsService';
import {AuthService} from '../../app/common/service/AuthService';
import {ConstantsService} from '../../app/common/service/ConstantsService';
import {WindowService} from '../../app/common/service/WindowService';
import {GSCaptureService} from '../../app/directives/gs-capture/GSCaptureService';
import {GSCaptureMultiService} from '../../app/directives/gs-capture-multi/GSCaptureMultiService';
import {GSGridService} from '../../app/directives/gs-grid/GSGridService';
import {GSSideService} from '../../app/directives/gs-sidebar/GSSideService';
import {GSVideoService} from '../../app/directives/gs-video/GSVideoService';
import {GSVideoClipDialogService} from '../../app/directives/gs-video/dialog/clip/GSVideoClipDialogService';
import {StreamDetailService} from '../../app/pages/admin/stream/detail/StreamDetailService';
import {StreamIndexService} from '../../app/pages/admin/stream/index/StreamIndexService';
import {TenantCameraService} from '../../app/pages/admin/tenant/camera/TenantCameraService';
import {TenantIndexService} from '../../app/pages/admin/tenant/index/TenantIndexService';
import {TenantDeleteDialogService} from '../../app/pages/admin/tenant/index/dialog/delete/TenantDeleteDialogService';
import {TenantEntryDialogService} from '../../app/pages/admin/tenant/index/dialog/entry/TenantEntryDialogService';
import {TenantMenuService} from '../../app/pages/admin/tenant/menu/TenantMenuService';
import {UserIndexService} from '../../app/pages/admin/user/index/UserIndexService';
import {UserEntryDialogService} from '../../app/pages/admin/user/index/dialog/entry/UserEntryDialogService';
import {CameraDetailService} from '../../app/pages/camera/detail/CameraDetailService';
import {DetectService} from '../../app/pages/camera/detect/DetectService';
import {CameraIndexService} from '../../app/pages/camera/index/CameraIndexService';
import {CameraMultiService} from '../../app/pages/camera/multi/CameraMultiService';
import {DashboardIndexService} from '../../app/pages/dashboard/index/DashboardIndexService';
import {DevtoolIndexService} from '../../app/pages/devtool/index/DevtoolIndexService';
import {LoginConfirmService} from '../../app/pages/login/confirm/LoginConfirmService';
import {LoginIndexService} from '../../app/pages/login/index/LoginIndexService';
import {PasswordIndexService} from '../../app/pages/password/index/PasswordIndexService';
/*-- service import end --*/

import { ContextMenuModule } from 'ngx-contextmenu';
import { ToastrModule } from 'ngx-toastr';

import { ColorPickerModule } from 'ngx-color-picker';

import { VgCoreModule } from 'ngx-videogular';
import { VgControlsModule } from 'ngx-videogular';
import { VgOverlayPlayModule } from 'ngx-videogular';
import { VgBufferingModule } from 'ngx-videogular';

import { AngularMaterialModule } from './AngularMaterialModule';


import { environment } from '../../environments/environment';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
const config: SocketIoConfig = { url: environment.socket_url, options: {} };

@NgModule({
  declarations: [
    /*-- declarations start --*/
    GSAlertDialogComponent
    ,GSCaptureComponent
    ,GSCaptureMultiComponent
    ,GSDialogComponent
    ,GSFooterComponent
    ,GSGridComponent
    ,GSHeaderComponent
    ,GSIconComponent
    ,GSSidebarComponent
    ,GSVideoComponent
    ,GSVideoClipDialogComponent
    ,StreamDetailComponent
    ,StreamIndexComponent
    ,TenantCameraComponent
    ,TenantIndexComponent
    ,TenantDeleteDialogComponent
    ,TenantEntryDialogComponent
    ,TenantMenuComponent
    ,UserIndexComponent
    ,UserEntryDialogComponent
    ,CameraDetailComponent
    ,DetectComponent
    ,CameraIndexComponent
    ,CameraMultiComponent
    ,DashboardIndexComponent
    ,DevtoolIndexComponent
    ,LoginConfirmComponent
    ,LoginIndexComponent
    ,PasswordIndexComponent
    ,AppComponent
    ,MainLayoutComponent
    ,TopNavLayoutComponent
    /*-- declarations end --*/
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgbModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ColorPickerModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    GridsterModule,
    ToastrModule.forRoot(),
    SocketIoModule.forRoot(config),
    ContextMenuModule.forRoot({
      autoFocus: true,
      useBootstrap4: true,
    }),
    AngularMaterialModule,
    /*-- routing start --*/
    StreamRoutingModule
    ,TenantRoutingModule
    ,UserRoutingModule
    ,CameraRoutingModule
    ,DashboardRoutingModule
    ,DevtoolRoutingModule
    ,LoginRoutingModule
    ,PasswoordRoutingModule
    /*-- routing end --*/
  ],

  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    BeforeunloadPlugin,
    /*-- service start --*/
    AnalyticsService
    ,AuthService
    ,ConstantsService
    ,WindowService
    ,GSCaptureService
    ,GSCaptureMultiService
    ,GSGridService
    ,GSSideService
    ,GSVideoService
    ,GSVideoClipDialogService
    ,StreamDetailService
    ,StreamIndexService
    ,TenantCameraService
    ,TenantIndexService
    ,TenantDeleteDialogService
    ,TenantEntryDialogService
    ,TenantMenuService
    ,UserIndexService
    ,UserEntryDialogService
    ,CameraDetailService
    ,DetectService
    ,CameraIndexService
    ,CameraMultiService
    ,DashboardIndexService
    ,DevtoolIndexService
    ,LoginConfirmService
    ,LoginIndexService
    ,PasswordIndexService
    /*-- service end --*/
  ],
  entryComponents: [],
  bootstrap: [AppComponent],
})
export class AppModule {}